import { Schema } from "effect"

/**
 * Why the owning org hid the profile. A small CLOSED set plus an `other` escape
 * hatch with a free-text note (owner_hidden_reason_note), so no user is ever
 * forced into a bucket.
 *
 * DELIBERATE, NARROW DEPARTURE from agent_docs/standards/user-empowerment.md —
 * that doc has NO bend covering this (review 2026-09-09; the "audit-required
 * operations" bullet is about auditing mutations on a user-managed catalogue and
 * does not license a fixed enum). The argument the doc DOES support: this is not
 * a user-organising taxonomy — nobody filters, groups or builds workflow on it;
 * it is a one-shot telemetry fact captured at the moment of hiding; it is
 * optional, so absence stays first-class (the doc's own primitive-design test);
 * and `other` + free note keeps every unforeseen reason expressible. A per-org
 * reason catalogue would be a primitive with no user who wants to manage it. If
 * `other` dominates in the data, the fifth code comes from that. (D4)
 *
 * Mirrors the CHECK constraint in liquibase v5.10-underwriter-owner-hidden.
 */
export const OwnerHiddenReasonCode = Schema.Literal(
  "updating_info",
  "not_writing_class",
  "capacity_paused",
  "other"
).annotations({
  identifier: "OwnerHiddenReasonCode",
  title: "Owner Hidden Reason",
  description: "Why the owning org hid the profile from the marketplace"
})
export type OwnerHiddenReasonCode = Schema.Schema.Type<typeof OwnerHiddenReasonCode>

/** Max length of the free-text note; enforced at the RPC boundary. */
export const OWNER_HIDDEN_NOTE_MAX_LENGTH = 500
